<script>
  let { text } = $props();
</script>

<div class="separator flex items-center">
  {text}
</div>
